<!-- This example requires Tailwind CSS v2.0+ -->
<template>
  <modal :open="open" @close="close()">
    <template v-slot:modelcontent>
      <div v-if="wasError">
        <h3 class="text-lg leading-6 font-medium text-gray-900">Purchase Failed</h3>

        <p class="mt-2 mb-5 text-sm text-gray-900">
          We could not register a purchase for this sign, please contact us to purchase this sign.
        </p>

        <button
            type="button"
            class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:w-auto sm:text-sm"
            @click="close" ref="cancelButtonRef">Cancel
        </button>
      </div>
      <div v-else-if="successfulPurchase">
        <h3 class="text-lg leading-6 font-medium text-gray-900">Purchase Successful</h3>

        <p class="mt-2 mb-5 text-sm text-gray-900">
        Your laminated register has been purchase.

        To see your invoice, please visit your billing portal
        </p>
        <a :href="billingpageurl"
           target = "_blank"
                class="float-right w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-uknar-primary text-base font-medium text-white hover:bg-uknar-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-uknar-primary sm:mt-0 sm:text-sm"
                @click="purchase" ref="cancelButtonRef">

          Visit Billing Portal
        </a>
      </div>
      <div v-else>
        <div>
          <h3 class="text-lg leading-6 font-medium text-gray-900">Purchase a laminated sign</h3>
          <p class="mt-2 text-sm text-gray-900">We have your card details on file, and we are able to send a laminated
            sign directly to you</p>
          <p class="mt-2 text-sm text-gray-900">Would you like to purchase a laminated sign for £{{ price }} and receive
            this in the post?</p>
        </div>
        <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
          <button
              type="button"
              class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:w-auto sm:text-sm"
              @click="close" ref="cancelButtonRef">Cancel
          </button>

          <button-loading
              @click="purchase"
              :loading="isProcessing"
              buttonlabel="Buy"
              buttonlabelloading="Processing..."
          ></button-loading>
        </div>
      </div>
    </template>
  </modal>
</template>

<script>
import {Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot} from '@headlessui/vue'
import {CheckIcon} from '@heroicons/vue/outline'

export default {
  props: {
    open: {
      type: Boolean,
      required: true,
      default: true
    },
    price: {
      type: String,
      required: true
    },
    billingpageurl: {
      type: String,
      required: true
    },
    buyendpoint: {
      type: String,
      required: true,
    }
  },
  components: {
    Dialog,
    DialogOverlay,
    DialogTitle,
    TransitionChild,
    TransitionRoot,
    CheckIcon,
  },
  data: function () {
    return {
      isProcessing: false,
      successfulPurchase: false,
      wasError: false
    };
  },
  methods: {
    close: function () {
      if (this.isProcessing === false) {
        this.$emit('closed', false);
      }
    },
    purchase: function () {
      let self = this;

      console.log(this.buyendpoint);

      if (this.isProcessing === false) {
        this.isProcessing = true;

        window.axios.post(this.buyendpoint)
          .then(response => {
            if(response.data.hasOwnProperty('success')) {
              self.successfulPurchase = response.data.success;
            }
          });
      }
    }
  }
}
</script>
